import ReqClient from './request.class'

// 创建推广计划
export async function creatCampaign (data) {
  const Req = new ReqClient({
    url: '/api/baidu/campaign/create',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取广告组
export async function getCampaign (params) {
  const Req = new ReqClient({
    url: '/api/baidu/campaign/get',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新广告组
export async function uploadCampaign (data) {
  const Req = new ReqClient({
    url: '/api/baidu/campaign/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加推广单元（第一步）
export async function addAdgroup (data) {
  const Req = new ReqClient({
    url: '/api/baidu/adGroup/addcaohuaplan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 添加推广单元（第二步）
export async function creatAdgroup (data) {
  const Req = new ReqClient({
    url: '/api/baidu/adGroup/addBaiduPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取推广单元详情
export async function getAdgroup (params) {
  const Req = new ReqClient({
    url: '/api/caohua/plan/queryByAdIdAndMediaId',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 更新推广单元
export async function updateAdgroup (data) {
  const Req = new ReqClient({
    url: '/api/baidu/adGroup/updateBaiduPlan',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 判断单元是否有创意
export async function beCreative (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/hasCreative',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取转化列表
export async function getConvert (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getOcpcTransFeed',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取覆盖人群
export async function getAudience (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getCrowdFeed',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询意图标签过滤条件
export async function getTagFilterFeed (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getIntentTagFilterFeed',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询意图标签
export async function getTags (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getIntentTagFeed',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询APP名称定向ID
export async function getAppIdName (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getAppIdNameFeed',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询推荐意图词包
export async function getRecmWordPackages (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getRecmWordPackagesFeed',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询意图词包
export async function getWtpFeed (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getWtpFeed',
    params
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 保存意图词包
export async function addWtpFeedSingle (data) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/addWtpFeedSingle',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 查询意图词关键词
export async function getRecmWord (data) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getRecmWord',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户上传的图片
export async function getImagesByAccount (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getImage',
    params
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取用户上传的视频
export async function getVideosByAccount (data) {
  const Req = new ReqClient({
    url: '/api/caohua/imageInfo/listUpload',
    method: 'POST',
    data
  })
  try {
    return await Req.reqData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传本地图片
export async function uploadLocalImage (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/uploadImage',
    timeout: 300000,
    params: {
      ad_account_id: params.account,
      file: params.file,
      width: params.width,
      height: params.height
    }
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 上传本地视频
export async function uploadLocalVideo (params) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/uploadVedio',
    timeout: 300000,
    params: {
      ad_account_id: params.account,
      width: params.width,
      height: params.height,
      file: params.file
    }
  })
  try {
    return await Req.reqFormData()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 创建创意
export async function creatCreative (data) {
  const Req = new ReqClient({
    url: '/api/baidu/creative/create',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 根据计划查询创意详情
export async function getCreative (data) {
  const Req = new ReqClient({
    url: '/api/baidu/creative/get',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 修改创意详情
export async function editCreative (data) {
  const Req = new ReqClient({
    url: '/api/baidu/creative/update',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}

// 获取转化列表
export async function getConvertList (data) {
  const Req = new ReqClient({
    url: '/api/baidu/tool/getConvertList',
    method: 'POST',
    data
  })
  try {
    return await Req.reqJson()
  } catch (e) {
    Req.handleError(e)
    return false
  }
}
